module.exports = __webpack_public_path__ + "img/base.899c9d74.png";